import { render, staticRenderFns } from "./IntegrationsNav.vue?vue&type=template&id=4448619b"
import script from "./IntegrationsNav.vue?vue&type=script&lang=js"
export * from "./IntegrationsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports